import type { BatchPreviewAssignPageProps } from "./batch-preview-assign-page.type";

import { useTranslation } from "react-i18next";

import { BatchPreviewPageDescription } from "../batch-preview-page-description";
import { BatchPreviewPageLayout } from "../batch-preview-page-layout";
import {
  useBatchPreviewGetUserName,
  useBatchPreviewIdsParam,
} from "../batch-preview.hook";

export const BatchPreviewAssignPage = ({
  model,
  children,
}: BatchPreviewAssignPageProps) => {
  const { t } = useTranslation();
  const { userName } = useBatchPreviewGetUserName();
  const { ids } = useBatchPreviewIdsParam();

  return (
    <BatchPreviewPageLayout
      title={t(`global:batchPreview.assign.${model}.title`)}
    >
      <BatchPreviewPageDescription
        i18nKey={`global:batchPreview.assign.${model}.description`}
        values={{ userName, count: ids.length }}
      />
      {children}
    </BatchPreviewPageLayout>
  );
};
